<template>
  <div>
    <div v-show="!bannerCropper" class="changebannerpop">
      <div class="logo-section-wrap-area">
        <div class="upload-eventlogo-head">
          <h3>Upload Event Logo <span>(Optional but recommended)</span></h3>
        </div>
        <v-row>
          <v-col cols="12" md="12" sm="12" class="mt-8 pb-8 divider-border">
            <h5 class="mb-2">Web Banner</h5>
            <div class="changebanner-wrap">
              <div class="change-banner-drop-sec">
                <img v-if="desktopBanner" :src="desktopBanner" />
                <img v-else src="../assets/Images/reg-ico/img-icon.svg" />
                <div class="trash-upload d-none">
                  <span
                    ><v-icon color="#fff" size="25px"
                      >mdi-trash-can-outline</v-icon
                    ></span
                  >
                </div>
              </div>
              <div class="drop-image-desc">
                <h5>
                  <a href="javascript:void();" @click="browseBanner(1)"
                    >Browse</a
                  >

                  <!-- <div class="custom--inputfile-btn-hld ml-2">
                  <input
                    id="fuLeftBanner"
                    type="file"
                    class="custom--inputfile"
                    @change="onBrowseComplete"
                  />
                  <v-btn
                    class="px-6"
                    depressed
                    color="primary"
                    @click="browseBanner(1)"
                  >
                    Browse
                  </v-btn>
                </div> -->
                  to add Banner
                </h5>
                <p>
                  Supported image formats: PNG, JPG <br />and recommended image
                  dimension <br />
                  {{ displayImageRatioWebBanner }}px<br />Max file size 5 MB
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="mt-8">
            <h5 class="mb-2">Mobile Responsive Banner</h5>
            <div class="changebanner-wrap">
              <div class="change-banner-drop-sec">
                <img v-if="mobileBanner" :src="mobileBanner" />
                <img v-else src="../assets/Images/reg-ico/img-icon.svg" />
                <div class="trash-upload d-none">
                  <span
                    ><v-icon color="#fff" size="25px"
                      >mdi-trash-can-outline</v-icon
                    ></span
                  >
                </div>
              </div>
              <div class="drop-image-desc">
                <h5>
                  <a href="javascript:void();" @click="browseBanner(2)"
                    >Browse</a
                  >
                  to add preview image
                </h5>
                <p>
                  Supported image formats: PNG, JPG <br />and recommended image
                  dimension <br />
                  {{ displayImageRatioMobileBanner }}px <br />Max file size 5 MB
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="12" class="mt-8">
            <h5 class="mb-2">Social Share Preview Banner</h5>
            <div class="changebanner-wrap">
              <div class="change-banner-drop-sec">
                <img v-if="shareBanner" :src="shareBanner" />
                <img v-else src="../assets/Images/reg-ico/img-icon.svg" />
                <div class="trash-upload d-none">
                  <span
                    ><v-icon color="#fff" size="25px"
                      >mdi-trash-can-outline</v-icon
                    ></span
                  >
                </div>
              </div>
              <div class="drop-image-desc">
                <h5>
                  <a href="javascript:void();" @click="browseBanner(3)"
                    >Browse</a
                  >
                  to add preview image
                </h5>
                <p>
                  Supported image formats: PNG, JPG <br />and recommended image
                  dimension {{ displayImageRatioShareBanner }}px <br />
                  Max file size 5 MB
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
        <input
          id="fuEventBanner"
          type="file"
          class="custom--inputfile"
          style="font-size: 0; visibility: hidden"
          accept="image/png, image/jpeg"
          @change="onBrowseComplete"
          onclick="this.value=null;"
        />
      </div>
      <v-divider class="m-0"></v-divider>
      <div
        class="
          save-settings
          d-flex
          justify-content-end
          align-items-center
          mt-4
          final-button
        "
      >
        <v-btn
          outlined
          class="mr-3"
          color="#1c1d26"
          width="120px"
          data-dismiss="modal"
          @click="CancelBannerUpload"
          large
          >Close</v-btn
        >
        <!-- <v-btn dark color="#1a73e8" width="120px" @click="SaveBanner"
          >Save</v-btn
        > -->
      </div>
    </div>

    <div
      v-if="bannerCropper"
      title="Crop Image"
      style="height: 100%; z-index: 999999"
    >
      <h5>
        <v-icon
          @click="bannerCropper = false"
          size="30"
          color="black"
          class="mr-2 cursor-pointer"
          >mdi-arrow-left</v-icon
        >
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <cropper
        :key="resetCropperKey"
        :aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        :file="imageFileDetails"
        :uploadPath="folderImageUploadPath"
        :clientId="clientId"
        :eventId="eventId"
        @uploadedImagePath="uploadedImagePath"
      />
    </div>
  </div>
</template>
<script>
// import HelloWorld from "@/components/HelloWorld.vue";
// import Router from "vue-router";
// import firebase from "firebase";
// import db from "../components/firebaseInit";
// import firebase from "firebase";
// import store from "../store";
// import router from "../router";
// import Vue from "vue";
// import VueMoment from "vue-moment";
// import moment from "moment-timezone";
// import jwt_decode from "jwt-decode";
import jQuery from "jquery";
let $ = jQuery;
import axios from "axios";
import APIs from "@/components/APIInit";
import { bus } from "@/main";
import Cropper from "../components/CropperComponent.vue";
var vm;
export default {
  components: {
    Cropper,
  },
  props: {
    event_collectionName: {
      type: String,
      default: "",
    },
    clientId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    paramDesktopBanner: {
      type: String,
      default: "",
    },
    paramMobileBanner: {
      type: String,
      default: "",
    },
    paramShareBanner: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uid: "",
      User: null,
      //imageRatio: 256 / 11,
      imageFileDetails: null,
      folderImageUploadPath: "",
      bannerId: 1,
      displayImageRatioWebBanner: "2048x88",
      displayImageRatioMobileBanner: "750x103",
      displayImageRatioShareBanner: "1200x628",
      desktopBanner: "",
      mobileBanner: "",
      shareBanner: "",
      bannerCropper: false,
      resetCropperKey: 0,
      cropImageUrl: null,
    };
  },
  computed: {
    displayImageRatio() {
      if (vm.bannerId == 1) {
        return vm.displayImageRatioWebBanner;
      } else if (vm.bannerId == 2) {
        return vm.displayImageRatioMobileBanner;
      } else if (vm.bannerId == 3) {
        return vm.displayImageRatioShareBanner;
      } else {
        return "";
      }
    },
    imageRatio() {
      if (vm.bannerId == 1) {
        return 256 / 11;
      } else if (vm.bannerId == 2) {
        return 750 / 103;
      } else if (vm.bannerId == 3) {
        return 300 / 157;
      } else {
        return 1 / 1;
      }
    },
  },
  watch: {},
  beforeCreate() {},
  created() {
    vm = this;
  },
  mounted() {
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.eventCollectionName = vm.getEventCollectionName();

    vm.bannerCropper = false;
    vm.bannerId = 1;

    // vm.desktopBanner = vm.paramDesktopBanner;
    // vm.mobileBanner = vm.paramMobileBanner;
    // vm.shareBanner = vm.paramShareBanner;
    if (!vm.desktopBanner) {
      vm.updateImages();
    }

    //FOR TEMPORARY BASIS
    // if (!vm.desktopBanner) {
    //   vm.desktopBanner =
    //     "https://storage.googleapis.com/uate2monair.appspot.com/OA_UAT_C1594240425613E1639074934324/Branding/1640709779583-e2m-banner-2048.png";
    // }
    // if (!vm.mobileBanner) {
    //   vm.mobileBanner =
    //     "https://storage.googleapis.com/uate2monair.appspot.com/OA_UAT_C1594240425613E1639074934324/Branding/1643384805439-expo-bg.jpg";
    // }
    // if (!vm.shareBanner) {
    //   vm.shareBanner =
    //     "https://storage.googleapis.com/uate2monair.appspot.com/OA_UAT_C1594240425613E1639074934324/Branding/1639765495309-image_2021_12_14t16_50_29_564z.png";
    // }
  },
  methods: {
    updateImages() {
      vm.desktopBanner = "";
      vm.desktopBanner = vm.getDesktopBanner(false);
      vm.mobileBanner = vm.getMobleBanner(false);
      vm.shareBanner = vm.getSocialShareBanner(false);
    },
    SaveBanner() {
      vm.showSnackbar("Banner uploaded successfully.", "info", "top");
      vm.$emit("onSaveBannerSuccess", {
        Status: 200,
        Message: "Image Uploaded Succesfully",
      });
    },
    setBrandingJson(mainKey, subKeyValObj = null) {
      debugger;
      let dataArr = [];
      if (Array.isArray(mainKey)) {
        for (let item of mainKey) {
          dataArr.push({
            mainKey: item.key,
            subKeys: Object.keys(item.obj),
            subKeyValObj: item.obj,
          });
        }
      } else {
        let subKeys = Object.keys(subKeyValObj);
        dataArr.push({
          mainKey: mainKey,
          subKeys: subKeys,
          subKeyValObj: subKeyValObj,
        });
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: dataArr,
      };
      axios.post(APIs.SaveEventBrandingJson, requestData, { headers: headers });
    },
    CancelBannerUpload() {
      vm.$emit("CancelBannerUpload");
    },
    saveEventinfo(
      eventKey,
      eventValue,
      brandingKey,
      brandingSubKey,
      brandingSubKeyValue,
      brandingSessionKey
    ) {
      debugger;
      bus.$emit("toggleLoader", true);
      let dataObj = new Object();
      dataObj[eventKey] = eventValue;

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: dataObj,
      };
      axios
        .post(APIs.SaveEventAPI, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 200) {
            vm.showSnackbar("Data updated", "success", "top");
            vm.setBrandingJson([
              {
                key: brandingKey,
                obj: { [brandingSubKey]: brandingSubKeyValue },
              },
            ]);
            vm.setBannerKey(brandingSessionKey, brandingSubKeyValue);
          } else {
            vm.showSnackbar("Data not updated!", "error", "top");
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          vm.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    uploadedImagePath(data) {
      debugger;
      if (data && data.Status == 200) {
        vm.cropImageUrl = null;
        vm.imageFileDetails = null;
        vm.folderImageUploadPath = null;
        if (vm.bannerId == 1) {
          vm.desktopBanner = data.Path;
          vm.saveEventinfo(
            "EventBanner",
            vm.desktopBanner,
            "banner",
            "2048x88",
            vm.desktopBanner,
            "banner"
          );
          // vm.setBrandingJson([
          //   { key: "banner", obj: { "2048x88": vm.desktopBanner } },
          // ]);
          //vm.setBrandingJson("2048x88",vm.desktopBanner)
        } else if (vm.bannerId == 2) {
          vm.mobileBanner = data.Path;
          vm.saveEventinfo(
            "EventBannerMobile",
            vm.mobileBanner,
            "banner",
            "750x103",
            vm.mobileBanner,
            "mobileBanner"
          );
          // vm.setBrandingJson([
          //   { key: "banner", obj: { "750x103": vm.mobileBanner } },
          // ]);
          //vm.setBrandingJson("750x103",vm.mobileBanner)
        } else if (vm.bannerId == 3) {
          vm.shareBanner = data.Path;
          vm.saveEventinfo(
            "EventBannerShare",
            vm.shareBanner,
            "banner",
            "1200x628",
            vm.shareBanner,
            "shareBanner"
          );
          // vm.setBrandingJson([
          //   { key: "banner", obj: { "1200x628": vm.shareBanner } },
          // ]);
          //vm.setBrandingJson("1200x628",vm.shareBanner)
        }
        vm.bannerCropper = false;
      } else {
        alert("fail");
      }
    },
    browseBanner(id) {
      debugger;
      //alert(vm.event_collectionName);
      vm.bannerId = id;
      //alert(vm.event_collectionName);
      vm.folderImageUploadPath = vm.event_collectionName + "/Branding/";
      $("#fuEventBanner").click();
    },
    onBrowseComplete(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      vm.sponsorLogoUploading = true;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        // var metadata = {
        //   contentType: file.type,
        // };

        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 5) {
          bus.$emit("toggleLoader", false);
          alert("File size exceeds 5 MB");
          return;
        }

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          // invalid file type code goes here.
          //alert("Only gif,jpeg & png file allowed.");
          vm.showSnackbar("Only gif,jpeg & png file allowed.", "error", "top");
          return false;
        }

        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          const reader = new FileReader();
          reader.onload = (e) => {
            //vm.imgSrc = e.target.result;
            vm.resetCropperKey++;
            vm.bannerCropper = true;
            vm.cropImageUrl = null;
            vm.cropImageUrl = e.target.result;
            vm.imageFileDetails = file;
            //bus.$emit("toggleLoader", false);
          };
          reader.readAsDataURL(file);
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  border-radius: 5px;
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>